import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import GiftItem from '../GiftItem';
import { DEFAULT_COUNTRY_CODE } from '../../utils/constants';

import s from './index.module.scss';

const RelatedGifts = ({ title = '', productIds, variant = 'default' }) => {
  const products = useSelector((state) => state.productsStorage.gifts);
  const gifts = [];

  productIds.forEach((id) => {
    if (products[id]) {
      gifts.push(
        <GiftItem
          product={products[id]}
          key={id}
          variant={DEFAULT_COUNTRY_CODE === 'GB' ? 'modern' : 'default'}
        />,
      );
    }
  });

  return (
    <div
      className={`${s['related-gifts']} ${s[`related-gifts-${variant}`]}`}
      data-analytics={'related-gifts'}
    >
      <div className={s['related-gifts__container']}>
        {title && <h3 className={s['related-gifts__title']}>{title}</h3>}
        <div className={s['related-gifts__items']}>{gifts}</div>
      </div>
    </div>
  );
};

RelatedGifts.propTypes = {
  variant: PropTypes.oneOf(['default', 'bestsellers']),
  title: PropTypes.string,
  productIds: PropTypes.arrayOf(PropTypes.number).isRequired,
};

export default RelatedGifts;
